const Marks = () => {
    return (
        <>
            <div
                id="centerMarkOne"
                className='mark'
                style={{ right: "45%" }}
            >
                <div className='mark-top'>05</div>
                <div className='mark-bottom'>05</div>
            </div>
            <div
                id="centerMarkTwo"
                className='mark'
                style={{ left: "45%" }}
            >
                <div className='mark-top'>05</div>
                <div className='mark-bottom'>05</div>
            </div>
            <div id="centerArea"
                className="area"
                style={{left: "45%", right: "45%", backgroundColor: "rgb(13, 205, 51)"}}
            >
            </div>
            <div
                id="twoScoreLeftMark"
                className='mark'
                style={{ left: "25%" }}
            >
                <div className='mark-top'>02</div>
                <div className='mark-bottom'>02</div>
            </div>
            <div id="twoScoreLeftArea"
                className="area"
                style={{left: "25%", right: "55%", backgroundColor: "rgb(167, 205, 13)"}}
            >
            </div>
            <div
                id="twoScoreRightMark"
                className='mark'
                style={{ left: "75%" }}
            >
                <div className='mark-top'>02</div>
                <div className='mark-bottom'>02</div>
            </div>
            <div id="twoScoreLeftArea"
                className="area"
                style={{left: "55%", right: "25%", backgroundColor: "rgb(167, 205, 13)"}}
            >
            </div>
            <div
                id="oneScoreLeftMark"
                className='mark'
                style={{ left: "0%" }}
            >
                <div className='mark-top'>01</div>
                <div className='mark-bottom'>01</div>
            </div>
            <div id="oneScoreLeftArea"
                className="area"
                style={{left: "0%", right: "75%", backgroundColor: "rgb(88, 109, 6)"}}
            >
            </div>
            <div
                id="oneScoreRightMark"
                className='mark'
                style={{ left: "100%" }}
            >
                <div className='mark-top'>01</div>
                <div className='mark-bottom'>01</div>
            </div>
            <div id="oneScoreLeftArea"
                className="area"
                style={{left: "75%", right: "0%", backgroundColor: "rgb(88, 109, 6)"}}
            >
            </div>
        </>
    );
}

export default Marks;